import { ReactNode } from 'react';
import {
  Earning_Mechanism_Product_Counting_Attribute,
  EarningMechanismFragment,
} from '@occc/graphql';
import { InfoField } from '@occc/ui-design-system';
import { earningMechanismHelper } from '@occc-app/offerHelpers/utils/earningMechanismHelper';
import { routeCreator as productGroupRouteCreator } from '@occc-app/routes/ProductGroup/utils';
import { OfferType } from '@occc-app/offerValidationService/types';
import { formatMoneyAmount } from '@occc-app/lib/currency';
import { pluralize } from '@occc-app/lib/strings';

import { ItemsOrViewAll } from '../../../components';
import { isVarietyPurchase } from '../configuration-section.utils';

const getVarietyPurchaseThresholdValue = (
  purchaseThreshold: number,
  countProductsBy: Earning_Mechanism_Product_Counting_Attribute,
): string => {
  if (countProductsBy === Earning_Mechanism_Product_Counting_Attribute.MoneyAmount) {
    return formatMoneyAmount(purchaseThreshold);
  }

  if (countProductsBy === Earning_Mechanism_Product_Counting_Attribute.UnitsCount) {
    return `${purchaseThreshold} ${pluralize(purchaseThreshold, 'unit')}`;
  }

  return `${purchaseThreshold} ${pluralize(purchaseThreshold, 'item')}`;
};

export const getVarietyPurchaseBlocks = (
  earningMechanism?: EarningMechanismFragment | null,
  offerType?: OfferType | null,
) => {
  const blocks: ReactNode[] = [];
  if (!isVarietyPurchase(earningMechanism)) {
    return blocks;
  }

  earningMechanism.products.forEach((product) => {
    const productGroups = product.eligibleProductGroups.map((pg) => ({
      id: pg.id,
      label: pg.name,
      href: productGroupRouteCreator.details(pg.id),
    }));

    blocks.push(
      <ItemsOrViewAll
        label='Purchase Threshold'
        value={getVarietyPurchaseThresholdValue(product.purchaseThreshold, product.countProductsBy)}
        itemName='Product Group'
        items={productGroups}
      />,
    );
  });

  if (offerType !== OfferType.ClubOrPunchcard) {
    blocks.push(
      <InfoField
        label='Limit Mode'
        value={
          earningMechanismHelper.isVarietyPurchase(earningMechanism)
            ? 'Per Transaction'
            : 'Over Time'
        }
      />,
    );
  }

  return blocks;
};
